// import { detectEnv } from '@/shared/detect';
// import yxhJsBridge from '@/shared/yxhJsBridge';
import type Router from 'vue-router';
import { useUserStore } from '@/stores/modules/user';
import type { Pinia } from 'pinia';

export default function loginGuard(router: Router, pinia: Pinia) {
  // if (detectEnv.webview) {
  // router.beforeEach((to, from, next) => {
  // if (to.name === 'NotFound' || to.name === 'ChunkLoadError') {
  //   next();
  //   return;
  // }
  // if (to.meta?.excludeLogin) {
  //   yxhJsBridge.getUserInfo().finally(() => {
  //     next();
  //   });
  // } else {
  //   yxhJsBridge
  //     .checkLogin()
  //     .then(() => {
  //       next();
  //     })
  //     .catch(() => {
  //       yxhJsBridge.close();
  //     });
  // }
  // });
  // } else {
  router.beforeEach((to, from, next) => {
    if (to.name === 'NotFound' || to.name === 'ChunkLoadError') {
      next();
      return;
    }
    const userStore = useUserStore(pinia);

    // 携带了token的情况下不调用登录页面
    if (to.query.token != null) {
      userStore.update({
        token: to.query.token as string,
      });
      next();
      return;
    }

    if (to.path === '/login' && userStore.isLogin) {
      next('/');
      return;
    }

    if (userStore.isLogin || to.meta?.excludeLogin) {
      next();
      return;
    }

    // next({
    //   path: '/login',
    //   query: {
    //     redirect: encodeURIComponent(to.fullPath),
    //   },
    //   replace: true,
    // });
  });
  // }
}
